// extracted by mini-css-extract-plugin
export default {"catalog":"BookCatalogPage_catalog__aO1Mr","grid":"BookCatalogPage_grid__hGYg+","pagination":"BookCatalogPage_pagination__m8X8F"};